/* [PATCH vasco-vp v1] Delovni čas → Šifranti → Vrste plačil (Vasco): povezava vrst iz Delovnega časa z vrstami plačil,
   šifra vrste plačila, naziv in kaj se vnaša (U ure, B bruto, N neto, T dnevi, OD/DD datum od/do, OB obdobje).
   Ureja samo admin podjetja. Podjetje ob prvem odprtju dobi kopijo privzete predloge.
   API: /kadri/{cid}/vrste-placil (GET, POST), /{id} (PUT, DELETE), /ponastavi (POST) — backend api/kadri.py. */
import React, { useCallback, useEffect, useState } from 'react';
import { Loader } from 'lucide-react';
import { api } from '../lib/api';

const napaka = (e: any) => e?.response?.data?.detail
  ? (typeof e.response.data.detail === 'string' ? e.response.data.detail : JSON.stringify(e.response.data.detail))
  : (e?.message || 'Napaka');
const kartica = 'bg-white dark:bg-gray-900 rounded-2xl border border-gray-200 dark:border-gray-700 p-4';
const gumb = 'px-4 py-2 rounded-lg text-sm font-medium bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50';
const gumb2 = 'px-3 py-2 rounded-lg text-sm font-medium border border-gray-200 dark:border-gray-700 hover:border-blue-400 bg-white dark:bg-gray-900';
const polje = 'w-full px-3 py-2 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 text-sm';
const lab = 'text-xs text-gray-500 block';
const PRAZEN_VNOS = { u: false, b: false, n: false, t: false, od: false, dd: false, ob: false, p: false }; /* [PATCH dc-opal-fe v1] + p */

export function VrstePlacil({ cid }: { cid: string }) {
  const [d, setD] = useState<any>(null);
  const [msg, setMsg] = useState<{ tip: 'ok' | 'napaka'; t: string } | null>(null);
  const [uredi, setUredi] = useState<any>(null);
  const [potrdi, setPotrdi] = useState<string | null>(null);
  const [dela, setDela] = useState(false);

  const nalozi = useCallback(() => {
    api.get(`/kadri/${cid}/vrste-placil`).then(r => setD(r.data)).catch(e => setMsg({ tip: 'napaka', t: napaka(e) }));
  }, [cid]);
  useEffect(() => { nalozi(); }, [nalozi]);
  useEffect(() => { if (msg?.tip !== 'ok') return; const t = setTimeout(() => setMsg(null), 3500); return () => clearTimeout(t); }, [msg]);

  if (!d) return msg ? <div className="px-3 py-2 rounded-lg border text-sm bg-red-50 text-red-700 border-red-200">{msg.t}</div>
    : <Loader className="w-5 h-5 animate-spin" />;

  const polja: any[] = d.polja || [];
  const zasedene = new Set((d.vrste || []).filter((v: any) => v.id && v.interna_vrsta && v.id !== uredi?.id).map((v: any) => v.interna_vrsta)); /* [PATCH dc-dodatki v2] vrstice brez šifre niso zasedene */
  const opal = d.program === 'opal'; /* [PATCH dc-opal-fe v1] program po podjetju (Profil podjetja → Računovodski program) */
  const prog = opal ? 'Opalu' : 'Vascu';
  const predogled = uredi && Number(uredi.sifra_vp) > 0
    ? polja.filter(p => uredi.vnos[p.kljuc]).map(p => p.crka + (opal ? String(Number(uredi.sifra_vp)).padStart(4, '0') : String(Number(uredi.sifra_vp)))).join(', ') : '';

  const nova = () => { setPotrdi(null); setMsg(null); setUredi({ id: null, interna_vrsta: '', sifra_vp: '', naziv: '', vnos: { ...PRAZEN_VNOS }, aktivna: true }); };
  const odpri = (v: any) => { setPotrdi(null); setMsg(null); setUredi({ ...v, interna_vrsta: v.interna_vrsta || '', sifra_vp: v.sifra_vp != null ? String(v.sifra_vp) : '', naziv: v.naziv || '', vnos: v.id ? { ...PRAZEN_VNOS, ...v.vnos } : { ...PRAZEN_VNOS, [d.program === 'opal' ? 'n' : 'b']: true } }); };
  const shrani = async () => {
    setMsg(null); setDela(true);
    const telo = { interna_vrsta: uredi.interna_vrsta || null, sifra_vp: Number(String(uredi.sifra_vp).trim()) || 0,
      naziv: String(uredi.naziv || '').trim() || null, vnos: uredi.vnos, aktivna: !!uredi.aktivna };
    try {
      if (uredi.id) await api.put(`/kadri/${cid}/vrste-placil/${uredi.id}`, telo);
      else await api.post(`/kadri/${cid}/vrste-placil`, telo);
      setUredi(null); setMsg({ tip: 'ok', t: 'Vrsta plačila shranjena' }); nalozi();
    } catch (e) { setMsg({ tip: 'napaka', t: napaka(e) }); } finally { setDela(false); }
  };
  const brisi = async (id: string) => {
    setDela(true);
    try { /* [PATCH dc-vrsta-brisi-fe v1] vrstica brez šifre = vrsta dodatka podjetja */
      if (id.startsWith('DODATEK:')) { await api.delete(`/kadri/${cid}/dodatki/vrste/${id.slice(8)}`); setMsg({ tip: 'ok', t: 'Vrsta dodatka izbrisana' }); }
      else { await api.delete(`/kadri/${cid}/vrste-placil/${id}`); setMsg({ tip: 'ok', t: 'Vrsta plačila izbrisana' }); }
      setPotrdi(null); if (uredi && (uredi.id || uredi.interna_vrsta) === id) setUredi(null); nalozi(); }
    catch (e) { setMsg({ tip: 'napaka', t: napaka(e) }); } finally { setDela(false); }
  };
  const ponastavi = async () => {
    setDela(true);
    try { const r = await api.post(`/kadri/${cid}/vrste-placil/ponastavi`); setD(r.data); setPotrdi(null); setUredi(null); setMsg({ tip: 'ok', t: 'Vrste plačil so ponastavljene na privzete' }); }
    catch (e) { setMsg({ tip: 'napaka', t: napaka(e) }); } finally { setDela(false); }
  };

  return (
    <div className="space-y-3">
      <div className="text-sm text-gray-500">
        {opal
          ? <>Katera vrsta iz Delovnega časa gre v katero vrsto plačila v Opalu in kaj se pri njej vnaša: u ure, t dni, n znesek,
              p odstotek. Oznaka = črka + 4-mestna šifra (npr. u0011, t4220). Pri izvozu se izpišejo samo stolpci s podatki.</>
          : <>Katera vrsta iz Delovnega časa gre v katero vrsto plačila v Vascu in kaj se pri njej vnaša. Pri izvozu se izpišejo samo
              stolpci s podatki; šifre nad 500 so v Vascu samo evidenčne in se ne obračunajo.</>}
      </div>
      {msg && <div className={'px-3 py-2 rounded-lg border text-sm ' + (msg.tip === 'ok' ? 'bg-green-50 text-green-700 border-green-200' : 'bg-red-50 text-red-700 border-red-200')}>{msg.t}</div>}
      <div className="flex items-center gap-2 flex-wrap">
        <button type="button" className={gumb} disabled={dela} onClick={nova}>Dodaj vrsto plačila</button>
        {potrdi === 'ponastavi'
          ? <span className="inline-flex items-center gap-2 text-sm">Vse vrstice podjetja se zamenjajo s privzetimi. Nadaljujem?
              <button type="button" className={gumb2 + ' !border-red-300 text-red-700'} disabled={dela} onClick={ponastavi}>Da, ponastavi</button>
              <button type="button" className={gumb2} onClick={() => setPotrdi(null)}>Ne</button></span>
          : <button type="button" className={gumb2} disabled={dela} onClick={() => setPotrdi('ponastavi')}>Ponastavi na privzeto</button>}
      </div>

      {uredi && (
        <div className={kartica + ' space-y-3'}>
          <div className="text-sm font-medium">{uredi.id ? 'Uredi vrsto plačila' : 'Nova vrsta plačila'}</div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
            <label className={lab + ' md:col-span-2'}>Povezava iz Delovnega časa
              <select className={polje} value={uredi.interna_vrsta} onChange={e => setUredi({ ...uredi, interna_vrsta: e.target.value })}>
                <option value="">— brez povezave (ročni vnos) —</option>
                {(d.interne || []).map((i: any) => <option key={i.kljuc} value={i.kljuc} disabled={zasedene.has(i.kljuc)}>{i.naziv}{zasedene.has(i.kljuc) ? ' (že povezano)' : ''}</option>)}
              </select></label>
            <label className={lab}>Šifra vrste plačila
              <input className={polje} inputMode="numeric" value={uredi.sifra_vp} onChange={e => setUredi({ ...uredi, sifra_vp: e.target.value.replace(/[^0-9]/g, '') })} /></label>
            <label className={lab}>Naziv
              <input className={polje} value={uredi.naziv} onChange={e => setUredi({ ...uredi, naziv: e.target.value })} /></label>
          </div>
          <div className="flex items-center gap-4 flex-wrap text-sm">
            <span className="text-xs text-gray-500">Vnaša se:</span>
            {polja.map(p => (
              <label key={p.kljuc} className="inline-flex items-center gap-1.5">
                <input type="checkbox" checked={!!uredi.vnos[p.kljuc]} onChange={e => setUredi({ ...uredi, vnos: { ...uredi.vnos, [p.kljuc]: e.target.checked } })} />
                {p.naziv} ({p.crka})</label>))}
            <label className="inline-flex items-center gap-1.5 border-l border-gray-200 dark:border-gray-700 pl-4">
              <input type="checkbox" checked={!!uredi.aktivna} onChange={e => setUredi({ ...uredi, aktivna: e.target.checked })} />Aktivna</label>
          </div>
          <div className="text-xs text-gray-500">Stolpci v {prog}: {predogled || '—'}</div>
          <div className="flex items-center gap-2">
            <button type="button" className={gumb} disabled={dela} onClick={shrani}>Shrani</button>
            <button type="button" className={gumb2} onClick={() => setUredi(null)}>Prekliči</button>
          </div>
        </div>
      )}

      <div className={kartica + ' overflow-x-auto'}>
        <table className="w-full text-sm">
          <thead><tr className="text-left text-gray-500 border-b border-gray-200 dark:border-gray-700">
            <th className="py-2 pr-3">Povezava iz Delovnega časa</th><th className="pr-3">Šifra</th><th className="pr-3">Naziv</th>
            <th className="pr-3">Stolpci v {prog}</th><th className="pr-3">Aktivna</th><th className="pr-3"></th></tr></thead>
          <tbody>
            {(d.vrste || []).map((v: any) => (
              <tr key={v.id || v.interna_vrsta} className={'border-b border-gray-100 dark:border-gray-800 cursor-pointer hover:bg-blue-50 dark:hover:bg-blue-500/10' + (v.aktivna ? '' : ' text-gray-400')}
                  onClick={() => odpri(v)}>
                <td className="py-2 pr-3">{v.interna_naziv || <span className="text-gray-400">ročni vnos</span>}</td>
                <td className="pr-3 font-medium">{v.sifra_vp ?? '—'}</td>
                <td className="pr-3">{v.naziv || '—'}</td>
                <td className="pr-3 text-xs">{v.brez_sifre ? <span className="text-amber-700">klikni in določi šifro</span> : ((v.formule || []).join(', ') || '—')}</td>
                <td className="pr-3">{v.aktivna ? 'da' : 'ne'}</td>
                <td className="pr-3 text-right whitespace-nowrap" onClick={e => e.stopPropagation()}>
                  {potrdi !== null && potrdi === (v.id || v.interna_vrsta) /* [PATCH dc-vrsta-brisi-fe v1] */
                    ? <span className="inline-flex items-center gap-2">Izbrišem?
                        <button type="button" className="text-red-700 hover:underline" disabled={dela} onClick={() => brisi(v.id || v.interna_vrsta)}>Da</button>
                        <button type="button" className="text-gray-500 hover:underline" onClick={() => setPotrdi(null)}>Ne</button></span>
                    : (v.id || String(v.interna_vrsta || '').startsWith('DODATEK:')) ? <button type="button" className="text-red-600 hover:underline" onClick={() => setPotrdi(v.id || v.interna_vrsta)}>Briši</button> : null}
                </td>
              </tr>))}
            {(d.vrste || []).length === 0 && <tr><td colSpan={6} className="py-4 text-center text-gray-400">Ni vrst plačil</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
